<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">
    <add-new-data-sidebar :isSidebarActive="addNewDataSidebar"  @getconifg="getconfig"  @closeSidebar="addNewDataSidebar = false" />
    <vs-table ref="table"  v-model="selected"  :max-items="10"  :data="users">
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center">
          <!-- 操作选项 -->
          <vs-dropdown vs-trigger-click class="cursor-pointer mr-4 mb-4">
            <div class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32">
              <span class="mr-2">操作</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="del()">
                <span>删除</span>
              </vs-dropdown-item>
              <vs-dropdown-item>
                <span @click="exportitem()">导出Excel</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>

          <!-- 新增 -->
          <div class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary" @click="addNewDataSidebar = true">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">添加标准</span>
          </div>
		  <div class="p-3 mb-4 mr-4 rounded-lg search-page__search-bar flex items-center">
		      <vs-input placeholder="名称搜索" v-model="searchQuery" class="w-full input-rounded-full no-icon-border" icon="icon-search" icon-pack="feather" />
		  </div>
		  <div class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between">
			  <vs-button color="primary" type="filled"  @click="search">搜索</vs-button>
		  </div>
        </div>
      </div>

      <template slot="thead">
        <vs-th >ID</vs-th>
        <vs-th >名称</vs-th>
        <vs-th >备注</vs-th>
		<vs-th >创建时间</vs-th>
		<vs-th >修改时间</vs-th>
		<vs-th >操作</vs-th>
      </template>

        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                <p class="product-name font-medium">{{ tr.id }}</p>
              </vs-td>
              <vs-td>
                <p class="product-category">{{ tr.name }}</p>
              </vs-td>
              <vs-td>
                <p class="product-price">{{ tr.remarks }}</p>
              </vs-td>
			  <vs-td>
			    <p class="product-price">{{ tr.createTime }}</p>
			  </vs-td>
			  <vs-td>
			    <p class="product-price">{{ tr.updateTime }}</p>
			  </vs-td>
			  <vs-td>
			    <vs-button color="primary" type="filled" @click="details(tr.id)">详情</vs-button>
				<vs-button color="rgb(62, 201, 214)" type="filled" @click="copyone(tr)" class="ml-4">复制</vs-button>
			  </vs-td>
            </vs-tr>
          </tbody>
        </template>
    </vs-table>
	<vs-pagination :total="total" v-model="itemsPerPage" ></vs-pagination>
	<div class="copy">
		<el-dialog
		  :close-on-click-modal="false"
		  title="复制标准"
		  :visible.sync="centerDialogVisible"
		  width="30%"
		  center>
		  <el-form   label-width="100px" class="demo-dynamic">
			<el-form-item label="复制标准:" class="formbtn">
			  <el-input :value="copywho" :disabled="true"></el-input>
			</el-form-item>
		    <el-form-item label="新增标准名称" class="formbtn">
		      <el-input v-model="copyname"></el-input>
		    </el-form-item>
		    <el-form-item label="新增标准备注">
		      <el-input v-model="copyremark"></el-input>
		    </el-form-item>
		  </el-form>
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="centerDialogVisible = false">取 消</el-button>
		    <el-button type="primary" @click="addcopy">确 定</el-button>
		  </span>
		</el-dialog>
	</div>
  </div>
</template>

<script>
import AddNewDataSidebar from '../../components/Addconfig.vue';

export default {
  components: {
    AddNewDataSidebar
  },
  data() {
    return {
      selected:'',
      users: [],
	  total:0,
	  searchQuery:'',   //搜索
      itemsPerPage: 1,
      addNewDataSidebar: false,
	  centerDialogVisible:false,
	  copywho:"",
	  copyid:'',
	  copyname:"",
	  copyremark:"",
    }
  },
  watch: {
      itemsPerPage:'getlist'
  }, 
  created() {
	  this.getlist();
  },
  methods: {
	  search(){   //搜索
		  this.itemsPerPage=1;
		  this.getlist();
	  },
	  del(){  //删除
		  const that = this;
		  if(this.selected){
			  this.$api.Configdel({id:this.selected.id}).then(function (response) {
			  	console.log("删除结果：",response);
			  	if(response.code==0){
			  		 that.$vs.notify({
			  		 	  title:"提示",
			  		 	  color:'success',
			  		 	  text:response.message,
			  		 	  position:'top-center'
			  		 });
					 that.selected='';
			  		 that.getlist();
			  	}else{
			  		that.$vs.notify({
			  			  title:"提示",
			  			  color:'warning',
			  			  text:response.message,
			  			  position:'top-center'
			  		});
			  	}
			  })
		  }else{
			  that.$vs.notify({
			  	  title:"提示",
			  	  color:'warning',
			  	  text:"请选择要删除的项",
			  	  position:'top-center'
			  });
		  }
	  },
	  exportitem(){
		  const that = this;
		  if(this.selected){
		  		let token = localStorage.getItem('token');
		  		window.open(`${this.$baseURL}/template/export?id=${that.selected.id}&authorization=${token}`);
		  }else{
		  	that.$vs.notify({
		  		title:"提示",
		  		color:'warning',
		  		text:"请选择要导出的项",
		  		position:'top-center'
		  	});
		  }
	  },
	  getconfig(config){   //添加标准
			console.log("标准：",config);
			const that = this;
			this.$api.Configadd({name:config.name,remarks:config.remarks}).then(function (response) {
				console.log("添加结果：",response);
				if(response.code==0){
					 that.$vs.notify({
						  title:"提示",
						  color:'success',
						  text:response.message,
						  position:'top-center'
					 });
					 that.addNewDataSidebar=false;
					 that.getlist();
				}else{
					that.$vs.notify({
						  title:"提示",
						  color:'warning',
						  text:response.message,
						  position:'top-center'
					});
				}
			})
	  },
	  getlist(){
		 const thisIns = this;
		 this.$api.Configlist({name:thisIns.searchQuery,pageNum:thisIns.itemsPerPage,pageSize:10}).then(function (response) {
		 	console.log("列表数据：",response);
		 	if(response.code==0){
		 		 thisIns.users=response.data.data;
		 		 thisIns.total=response.data.pages;
		 	}else{
		 		thisIns.$vs.notify({
		 			  title:"提示",
		 			  color:'warning',
		 			  text:response.message,
		 			  position:'top-center'
		 		});
		 	}
		   }) 
	  },
	  details(id){
		  this.$router.push({path:'/admin/configdetails',query:{id:id}})
	  },
	  copyone(item){
		  console.log("复制一份",item);
		  this.copywho=item.name;
		  this.copyid=item.id;
		  this.copyname="";
		  this.copyremark="";
		  this.centerDialogVisible=true;
	  },
	  addcopy(){
		  var that=this;
		if(that.copyname==''){
			that.$vs.notify({
				title:"提示",
				color:'warning',
				text:"请输入标准名称",
				position:'top-center'
			});
			return false
		}
		this.$api.Copytemplate({id:that.copyid,name:that.copyname,remarks:that.copyremark}).then(function (response) {
			if(response.code==0){
				 that.$vs.notify({
				 	  title:"提示",
				 	  color:'success',
				 	  text:response.message,
				 	  position:'top-center'
				 });
				 that.centerDialogVisible=false;
				 that.getlist();
			}else{
				that.$vs.notify({
					  title:"提示",
					  color:'warning',
					  text:response.message,
					  position:'top-center'
				});
			}
		})
	  },
  },
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
